import { render, staticRenderFns } from "./cookieFormModel.vue?vue&type=template&id=379fbeee&scoped=true"
import script from "./cookieFormModel.vue?vue&type=script&lang=js"
export * from "./cookieFormModel.vue?vue&type=script&lang=js"
import style0 from "./cookieFormModel.vue?vue&type=style&index=0&id=379fbeee&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "379fbeee",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('379fbeee')) {
      api.createRecord('379fbeee', component.options)
    } else {
      api.reload('379fbeee', component.options)
    }
    module.hot.accept("./cookieFormModel.vue?vue&type=template&id=379fbeee&scoped=true", function () {
      api.rerender('379fbeee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/settings/components/cookieFormModel.vue"
export default component.exports